import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface LanguageOption {
  code: string;
  native_name: string;
}

interface TemplateTranslationsProps {
  languages?: LanguageOption[];
  activeLang: string;
  onActiveLangChange: (lang: string) => void;
  nameI18n: Record<string, string>;
  onNameChange: (lang: string, value: string) => void;
  descI18n: Record<string, string>;
  onDescChange: (lang: string, value: string) => void;
}

export const TemplateTranslations = ({
  languages,
  activeLang,
  onActiveLangChange,
  nameI18n,
  onNameChange,
  descI18n,
  onDescChange,
}: TemplateTranslationsProps) => {
  return (
    <div className="space-y-4 border rounded-lg p-4 bg-muted/30">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium text-foreground">Translations</h3>
        <div className="w-48">
          <Select value={activeLang} onValueChange={onActiveLangChange}>
            <SelectTrigger>
              <SelectValue placeholder="Language" />
            </SelectTrigger>
            <SelectContent>
              {(languages || []).map((l) => (
                <SelectItem key={l.code} value={l.code}>
                  {l.native_name} ({l.code})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label>Localized Name ({activeLang})</Label>
          <Input
            value={nameI18n[activeLang] || ''}
            onChange={(e) => onNameChange(activeLang, e.target.value)}
            placeholder="Translated template name"
          />
        </div>
        <div className="space-y-2">
          <Label>Localized Description ({activeLang})</Label>
          <Textarea
            value={descI18n[activeLang] || ''}
            onChange={(e) => onDescChange(activeLang, e.target.value)}
            placeholder="Translated description"
            rows={3}
          />
        </div>
      </div>
    </div>
  );
};

export default TemplateTranslations;

